const expertiseItems = [
  {
    title: 'iOS Platform Engineering',
    description: 'Design and development of modern digital solutions for the iOS ecosystem, leveraging the latest platform capabilities and frameworks.',
    variant: 'primary' as const,
  },
  {
    title: 'Scalable Architecture',
    description: 'Building maintainable systems with clean architecture principles that scale gracefully as requirements evolve and user bases grow.',
    variant: 'accent' as const,
  },
  {
    title: 'Performance Optimization',
    description: 'Deep focus on system performance, resource efficiency, and responsive user experiences through rigorous profiling and tuning.',
    variant: 'primary' as const,
  },
];

export default function ExpertiseSection() {
  return (
    <section className="w-full bg-background-50 py-28 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-20 lg:px-[100px]">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-16 mb-16 md:mb-20">
          <div className="flex-shrink-0">
            <p className="font-label text-sm font-medium uppercase tracking-[0.08em] text-secondary-500">
              What We Do
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-[42px] font-bold text-foreground-950 mt-3 leading-tight">
              Core Engineering
              <br />
              Capabilities
            </h2>
          </div>
          <div className="lg:ml-auto max-w-[520px]">
            <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed">
              Our team follows modern software engineering practices, including clean architecture,
              performance optimization, and user-centered design to deliver reliable and future-ready
              solutions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {expertiseItems.map((item) => (
            <div
              key={item.title}
              className={`rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[340px] ${
                item.variant === 'accent'
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-primary-500 text-background-50'
              }`}
            >
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold leading-snug">
                  {item.title}
                </h3>
                <p
                  className={`mt-4 font-body text-sm md:text-base leading-relaxed ${
                    item.variant === 'accent'
                      ? 'text-background-50/75'
                      : 'text-background-50/70'
                  }`}
                >
                  {item.description}
                </p>
              </div>
              <div
                className={`mt-8 w-10 h-10 rounded-full flex items-center justify-center ${
                  item.variant === 'accent'
                    ? 'bg-background-50/15'
                    : 'bg-background-50/10'
                }`}
              >
                <i className={`ri-arrow-right-line text-lg ${item.variant === 'accent' ? 'text-background-50' : 'text-background-50'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}